import { render, staticRenderFns } from "./FolderContainer.vue?vue&type=template&id=bcfd1e1c&scoped=true"
import script from "./FolderContainer.vue?vue&type=script&lang=js"
export * from "./FolderContainer.vue?vue&type=script&lang=js"
import style0 from "./FolderContainer.vue?vue&type=style&index=0&id=bcfd1e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfd1e1c",
  null
  
)

export default component.exports